import React, { FC, useState } from 'react';
import { WalletIcon } from 'cokitchen-icons';
import { toast } from 'react-toastify';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'utils/api';
import { OrderType } from 'models/order.model';

interface ConfirmPaymentModalProps {
  show: boolean;
  onClose: () => void;
  order: OrderType;
}

interface ConfirmPaymentFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmPaymentFooter: FC<ConfirmPaymentFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const ConfirmPaymentModal: FC<ConfirmPaymentModalProps> = ({ show, onClose, order }) => {
  const [loading, setLoading] = useState(false);
  const confirmPayment = async () => {
    try {
      setLoading(true);
      await apiService.post(`kitchen/order/paid/${order?.order_code}`, {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Order confirmed successfully' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <BaseModal
      isOpen={show}
      title='Confirm Payment'
      description={`Are you sure you want to confirm order #${order?.order_code?.toUpperCase()} ?`}
      titleIcon={<WalletIcon />}
      titleIconColor='gray'
      onRequestClose={onClose}
      footer={
        <ConfirmPaymentFooter loading={loading} onCancel={onClose} onConfirm={confirmPayment} />
      }
    />
  );
};

export default ConfirmPaymentModal;
